import React from "react";

export default function Briefcase() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="32"
      fill="none"
      viewBox="0 0 33 32"
    >
      <path
        fill="#76A9FA"
        fillRule="evenodd"
        d="M9.913 9.6V8a4.8 4.8 0 014.8-4.8h3.2a4.8 4.8 0 014.8 4.8v1.6h3.2a3.2 3.2 0 013.2 3.2v5.712a36.722 36.722 0 01-12.8 2.288 36.722 36.722 0 01-12.8-2.288V12.8a3.2 3.2 0 013.2-3.2h3.2zm3.2-1.6a1.6 1.6 0 011.6-1.6h3.2a1.6 1.6 0 011.6 1.6v1.6h-6.4V8zm1.6 8a1.6 1.6 0 011.6-1.6h.016a1.6 1.6 0 010 3.2h-.016a1.6 1.6 0 01-1.6-1.6z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#76A9FA"
        d="M3.513 21.907V25.6a3.2 3.2 0 003.2 3.2h19.2a3.2 3.2 0 003.2-3.2v-3.693A39.957 39.957 0 0116.313 24c-4.474 0-8.78-.736-12.8-2.093z"
      ></path>
    </svg>
  );
}
